import React from 'react';
import { withTranslation } from 'react-i18next';

function Loading({ t }) {
	return <p>{t('Loading')}</p>;
}

export default withTranslation()(Loading);
